import { ICommand } from 'core-ts-types';
import { AccountModel } from 'data-ng-authentication';
import * as _4 from 'lodash4';

export function PriorityFeedRoutes($stateProvider: any) {
  $stateProvider.state('my.feed', {
    url: 'priority-feed/',
    templateUrl: 'capability-ng-priority-feed/src/views/priority_feed/priority_feed.html',
    controller: 'PriorityFeedController',
    controllerAs: '$ctrl',
    sticky: true,
    onEnter: (
      loadPriorityFeedDataCommand: ICommand,
      accountModel: AccountModel,
      loadAccountCommand: ICommand,
      loadAllCustomTextCommand: ICommand
    ) => {
      if (_4.isEmpty(accountModel.student_nk)) {
        loadAccountCommand().then(() => {
          loadPriorityFeedDataCommand();
          loadAllCustomTextCommand();
        });
      } else {
        loadPriorityFeedDataCommand();
        loadAllCustomTextCommand();
      }
    },
    data: {
      ignoredInHistory: false,
      pageTitle: 'Home'
    }
  });
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/routes.ts